import { useEffect, useState } from "react";
import React, { lazy } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router";
import Cookies from "js-cookie";
import MainSideMenu from "../Menu/SideMenu/MainSideMenu";
import NotificationMenu from "../Menu/NotificationMenu/NotificationMenu";
import {
  DashboardIcon,
  AdminBooking,
  AllBookings,
  AllRoom,
  MyBooking,
  UserManagementIcon
} from "../../utils/IconConstant";
import { Div, Flexbox, WorkArea, WrapperBox } from "../../MakersV2/Theme/GlobalStyles.jsx";
import { globalTheme } from "../../MakersV2/Theme/Theme.jsx";
import { BloomBergLogo, BookingsIcon, BuildingIcon, ChartIcon, ClockIcon, CoworkLogoTextWhite, EduspaceLogoWhite, GuideIcon, HelpIcon, LogOut, MakersLogo, Notification, Users } from "../../MakersV2/Theme/Icons.jsx";
import InitialsAvatar from "../../MakersV2/Components/InitialsAvatar.jsx";
import { ToolTip } from "../../MakersV2/Components/ToolTip/ToolTip.jsx";
import { Text } from "../../MakersV2/Theme/Typography.jsx";
import { logout } from "../../redux/authentication/authSlice.js";
import LogoutPopup from "../../MakersV2/Components/Popup/LogoutPopup.jsx";
import { MODULES, selectAppModule } from "../../redux/appModule/appModuleSlice.js";

const GetAllBookings = lazy(() => import("../../Pages/GetAllBookings/GetAllBookings"));

const MyBookings = lazy(() => import("../../Pages/MyBookings/MyBookings.jsx"));

const AvailableRooms = lazy(() => import("../../Pages/AvailableRooms/AvailableRooms"));

const ClassroomAvailableRooms = lazy(() => import("../../Pages/ClassroomAvailableRooms/ClassroomAvailableRooms"));

export const renderDashboardBasedOnRole = () => {
  // Logic to determine the user's roles and return the appropriate dashboard component
  // ...
  const currentUrl = window.location.hostname;
	const isClassroomTheme = currentUrl.includes('classroom.mastersunion.org') || currentUrl.includes('classroom')  || 
    currentUrl.includes('localhost');
	const isCoworkTheme = currentUrl.includes('cowork.mastersunion.org');
	const isMakersLabTheme = currentUrl.includes('makerslab.mastersunion.org') || currentUrl.includes('makersv2') || currentUrl.includes('127.0.0.1') ;

  const rolesCookie = Cookies.get("roles");
  const rolesArray = rolesCookie ? JSON.parse(rolesCookie) : [];
  // const rolesArray = JSON.parse(Cookies.get("roles"));
  const userRoles = rolesArray; // Example roles (array of roles)

  console.log("printing roles data", rolesArray);

  // Map roles to their corresponding dashboard components
  const roleDashboardMap = {
    "Cowork Admin" : <AvailableRooms />,
    "Cowork Staff" : <AvailableRooms />,
    "Cowork Student" : <AvailableRooms />,
    "Cowork Faculty" : <AvailableRooms />,
    "Cowork UL Booking":<AvailableRooms />,
    "Cowork Class Admin":<AvailableRooms />,
    "Cowork Class User":<ClassroomAvailableRooms />,
  };

  // Find the first matching role from the userRoles array
  const matchingRole = userRoles.find((role) =>
    roleDashboardMap.hasOwnProperty(role)
  );

  // Retrieve the dashboard component based on the matching role or default component
  const dashboardComponent =
    roleDashboardMap[matchingRole] || roleDashboardMap.default;

  // Return the dashboard component
  return dashboardComponent;
};

export const renderMenuItemsBasedOnRole = (selectedModule) => {
  // Replace this with your logic to determine the user's role

  const currentUrl = window.location.hostname;
  const isMakersLabTheme = selectedModule === MODULES.MAKERSLAB ;
  const isClassroomTheme = selectedModule === MODULES.EDUSPACE ;
  const isCoworkTheme = selectedModule === MODULES.COWORK ;
  const isBloombergTheme = selectedModule === MODULES.BLOOMBERG ;

  const rolesCookie = Cookies.get("roles");
  const rolesArray = rolesCookie ? JSON.parse(rolesCookie) : [];
  // const rolesArray = JSON.parse(Cookies.get("roles"));
  const userRole = rolesArray; // Example roles (array of roles)

  const roleMenuItemsMap = {
    "Cowork Admin": isCoworkTheme ? [
      {
        label: "Dashboard",
        path: "/admin-dashboard",
        icon: <ChartIcon />,
      },
      {
        label: "Meeting Rooms",
        path: "/MeetingRooms",
        icon: <BuildingIcon />,
      },
      
      {
        label: "Bookings",
        path: "/user-bookings",
        icon: <BookingsIcon/>,
      },
      {
        label: "Availability",
        path: "/user-dashboard",
        icon: <ClockIcon />,
      },
      {
        label: "User Control",
        path: "/user-management",
        icon: <Users/>,
      },
    ] : [],
    "Cowork Class Admin": isClassroomTheme ? [
      {
        label: "Dashboard",
        path: "/eduspace-dashboard",
        icon: <ChartIcon />,
      },
      {
        label: "Meeting Rooms",
        path: "/MeetingRooms",
        icon: <BuildingIcon />,
      },
      
      {
        label: "Bookings",
        path: "/user-bookings",
        icon: <BookingsIcon />,
      },
      {
        label: "Availability",
        path: "/user-dashboard",
        icon: <ClockIcon />,
      },
      {
        label: "User Control",
        path: "/user-management",
        icon: <Users />,
      },
    ]
     : [],
    // "Cowork Admin": [
    //   {
    //     label: "All Rooms",
    //     path: "/allLabs",
    //     icon: <AllRoom />,
    //   },
    //   {
    //     label: "User Control",
    //     path: "/user-management",
    //     icon: <UserManagementIcon />,
    //   },
    //   {
    //     label: "Book Room",
    //     path: "/classroom-available-rooms",
    //     icon: <AllRoom />,
    //   },
    //   {
    //     label: "My Requests",
    //     path: "/classroom-my-requests",
    //     icon: <MyBooking />,
    //   },
    //   {
    //     label: "All Requests",
    //     path: "/classroom-all-requests",
    //     icon: <AllBookings />,
    //   },
    // ] ,
    "Cowork Lab Admin": isMakersLabTheme ? [
      {
        label: "Dashboard",
        path: "/admin-dashboard",
        icon: <ChartIcon />,
      },
      {
        label: "Meeting Rooms",
        path: "/MeetingRooms",
        icon: <BuildingIcon />,
      },
      
      {
        label: "Bookings",
        path: "/user-bookings",
        icon: <BookingsIcon />,
      },
      {
        label: "Availability",
        path: "/user-dashboard",
        icon: <ClockIcon />,
      },
    ] : [],
    "Cowork Class User": isClassroomTheme ? [
      {
        label: "Dashboard",
        path: "/eduspace-dashboard",
        icon: <ChartIcon />,
      },
      {
        label: "Availability",
        path: "/user-dashboard",
        icon: <ClockIcon />,
      },
    ] : [],
    "Cowork Lab Student": isMakersLabTheme ? [
      {
        label: "Book Lab",
        path: "/classroom-available-rooms",
        icon: <AllRoom />,
      },
      {
        label: "My Lab Requests",
        path: "/classroom-my-requests",
        icon: <MyBooking />,
      },
    ] : [],
    "BMB Admin": isBloombergTheme ? [
      {
        label: "Dashboard",
        path: "/admin-dashboard",
        icon: <AdminBooking />,
      },
      {
        label: "Meeting Rooms",
        path: "/MeetingRooms",
        icon: <MyBooking />,
      },
      {
        label: "Bookings",
        path: "/user-bookings",
        icon: <AllBookings />,
      },
      {
        label: "Availability",
        path: "/user-dashboard",
        icon: <UserManagementIcon />,
      },
    ] : [],
    "BMB Student": isBloombergTheme ? [
      {
        label: "Book Room",
        path: "/classroom-available-rooms",
        icon: <AllRoom />,
      },
      {
        label: "My Requests",
        path: "/classroom-my-requests",
        icon: <MyBooking />,
      },
    ] : [],
    "Cowork Faculty": isCoworkTheme ? [
      {
        label: "All Rooms",
        path: "/",
        icon: <AllRoom />,
      },
      {
        label: "My Bookings",
        path: "/mybookings",
        icon: <MyBooking />,
      },
    ] : [],

    "Cowork Staff": isCoworkTheme ? [
      {
        label: "All Rooms",
        path: "/",
        icon: <AllRoom />,
      },
      {
        label: "My Bookings",
        path: "/mybookings",
        icon: <MyBooking />,
      },
    ] : [],
    "Cowork UL Booking": isCoworkTheme ? [
      {
        label: "All Rooms",
        path: "/",
        icon: <AllRoom />,
      },
      {
        label: "My Bookings",
        path: "/mybookings",
        icon: <MyBooking />,
      },
    ] : [],
    "Cowork Student": isCoworkTheme ? [
      {
        label: "All Rooms",
        path: "/",
        icon: <AllRoom />,
      },
      {
        label: "My Room Bookings",
        path: "/mybookings",
        icon: <MyBooking />,
      },
    ] : [],

    
    default: [
      { label: "Dashboard", path: "/", icon: <DashboardIcon /> },
    ],
  };

  // Combine menu items for all roles
  const mergedMenuItems = userRole.reduce((mergedItems, role) => {
    const roleMenuItems = roleMenuItemsMap[role] || roleMenuItemsMap.default;
    return mergedItems.concat(roleMenuItems);
  }, []);

  // Remove duplicates from merged menu items
  const uniqueMenuItems = mergedMenuItems.filter(
    (menuItem, index, self) =>
      index === self.findIndex((m) => m.label === menuItem.label)
  );

  // Appended after the merge rather than inside the role arrays: those are concatenated
  // in cookie-role order, so a dual-role user (Class User + Class Admin) would otherwise
  // see Guidelines wherever the first role happened to put it. Help always sits last.
  if (isClassroomTheme && uniqueMenuItems.length) {
    uniqueMenuItems.push({
      label: "Guidelines",
      path: "/eduspace-guidelines",
      icon: <GuideIcon />,
    });
  }

  return uniqueMenuItems;
};

const MainLayout = () => {
  const selectedModule = useSelector(selectAppModule);
  useEffect(() => {
    renderMenuItemsBasedOnRole(selectedModule);
  }, []);

  const [isActiveMenu, setIsActiveMenu] = useState(false)
    const [popupState, setPopupState] = useState(false);
    const [allowLogout, setAllowLogout] = useState(false);
    const navigate = useNavigate();
      const dispatch = useDispatch();
  
  // Check if user has Class Admin or Class User role
  const rolesCookie = Cookies.get("roles");
  const rolesArray = rolesCookie ? JSON.parse(rolesCookie) : [];

  // Logged-in user's name + a human-readable role for the header avatar tooltip
  // (same mapping the sidebar uses).
  const loginDataCookie = Cookies.get("loginData");
  const authData = loginDataCookie ? JSON.parse(loginDataCookie) : {};
  const roleText =
    rolesArray?.includes("Cowork Class Admin") || rolesArray?.includes("Cowork Lab Admin") || rolesArray?.includes("Cowork Admin") || rolesArray?.includes("BMB Admin") ? "Admin" :
    rolesArray?.includes("Cowork Lab Student") || rolesArray?.includes("Cowork Student") || rolesArray?.includes("BMB Student") ? "Student" :
    rolesArray?.includes("Cowork Staff") ? "Staff" :
    rolesArray?.includes("Cowork Faculty") ? "Faculty" :
    "";
  const isClassroomUser = rolesArray.includes("Cowork Class User") && selectedModule === MODULES.EDUSPACE;
  const isCoworkAdmin = rolesArray.includes("Cowork Admin") && selectedModule === MODULES.COWORK;
  const isClassroomAdmin = rolesArray.includes("Cowork Class Admin") && selectedModule === MODULES.EDUSPACE;
  const isLabAdmin = rolesArray.includes("Cowork Lab Admin") && selectedModule === MODULES.MAKERSLAB;
  const isBmbAdmin = rolesArray.includes("BMB Admin") && selectedModule === MODULES.BLOOMBERG;

  useEffect(() => {
      const handleLogout = () => {
        // Get an array of all cookie names
        var allCookies = Object.keys(Cookies.get());
  
        // Loop through the cookie names and remove each cookie
        allCookies.forEach(function (cookieName) {
          Cookies.remove(cookieName);
        });
        dispatch(logout());
        navigate("/login");
      };
      if (allowLogout) {
        handleLogout();
      }
    }, [allowLogout]);

    const handleHelpIconClick = () => {
      authData.officialEmail.includes("tetr.org") ? window.open("https://coach.tetr.com/raise-concern/technicalSupport", "_blank") : window.open(" https://coach.mastersunion.org/raise-concern/technicalSupport", "_blank");
    }

  return (
    <>
    	<LogoutPopup
				showActive={popupState}
				message={"Are you sure you want to log out? You will need to sign in again to access your account."}
				onCancel={setPopupState}
				onAllow={setAllowLogout}
			/>
    <WorkArea className={` ${isClassroomUser ? 'classroom-theme' : ''}`}>
      <Flexbox height='100vh'>

      {(isCoworkAdmin || isClassroomUser || isClassroomAdmin || isLabAdmin || isBmbAdmin) && 
        <MainSideMenu menuItems={renderMenuItemsBasedOnRole(selectedModule)} isActiveMenu={isActiveMenu} setIsActiveMenu={setIsActiveMenu} /> 
      }        
      {/* <NotificationMenu setIsActiveMenu={setIsActiveMenu} isActiveMenu={isActiveMenu}/> */}
       <WrapperBox background={isClassroomUser? globalTheme.colors.white:globalTheme.colors.black4 }  padding={'0'} className="appContentArea">
      {/* Drawer trigger. Only rendered when a sidebar exists to open, and only
          visible below 992px (.mobileTopBar) where that sidebar is off-canvas. */}
      {(isCoworkAdmin || isClassroomUser || isClassroomAdmin || isLabAdmin || isBmbAdmin) && (
        <Flexbox
          className="mobileTopBar"
          alignCenter
          gap={14}
          padding={'12px 16px'}
          background={globalTheme.colors.black4}
        >
          <button
            type="button"
            onClick={() => setIsActiveMenu(true)}
            aria-label="Open menu"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 4,
              width: 36,
              height: 36,
              flexShrink: 0,
              borderRadius: 10,
              cursor: 'pointer',
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.14)',
            }}
          >
            {[0, 1, 2].map((i) => (
              <span
                key={i}
                style={{ display: 'block', width: 16, height: 2, borderRadius: 2, background: '#fff' }}
              />
            ))}
          </button>
          {selectedModule === MODULES.EDUSPACE ? (
            <EduspaceLogoWhite />
          ) : selectedModule === MODULES.MAKERSLAB ? (
            <MakersLogo />
          ) : selectedModule === MODULES.BLOOMBERG ? (
            <BloomBergLogo />
          ) : (
            <CoworkLogoTextWhite />
          )}
        </Flexbox>
      )}
      {/* overflow visible so the avatar tooltip can spill below the header bar
          (WrapperBox clips by default). */}
      {!(isCoworkAdmin || isClassroomAdmin || isClassroomUser || isLabAdmin || isBmbAdmin) &&
      <WrapperBox background={globalTheme.colors.black4} padding={'20px 30px'} overflow={'visible'}>
          <Flexbox spaceBW  >
            {/* Logo follows the active module instead of always showing Makers Lab. */}
            {selectedModule === MODULES.EDUSPACE ? (
              <EduspaceLogoWhite />
            ) : selectedModule === MODULES.MAKERSLAB ? (
              <MakersLogo />
            ) : selectedModule === MODULES.BLOOMBERG ? (
              <BloomBergLogo />
            ) : (
              <CoworkLogoTextWhite />
            )}
            <Flexbox flexEnd gap={12} alignCenter>
              {/* <WrapperBox background={globalTheme.colors.black4} padding={'9px'} borderRadius={50} borderColor={globalTheme.colors.grey2} maxWidth={'max-content'}>
                <Notification />
              </WrapperBox> */}
              {
                rolesArray?.includes("Cowork Student") && 
                <ToolTip
                  position="Bottom"
                  zIndex="9999"
                  minWidth="max-content"
                  maxWidth="max-content"
                  content={
                    <Text font13 inter medium white style={{ whiteSpace: 'nowrap' }}>
                      Help
                    </Text>
                  }
                >
                  <HelpIcon onClick={handleHelpIconClick} className={'pointer'} />
                </ToolTip>
              }
              
              <ToolTip
                position="Bottom"
                zIndex="9999"
                minWidth="max-content"
                maxWidth="max-content"
                content={
                  <Flexbox column gap={4} alignStart style={{ padding: '2px 4px' }}>
                    <Text font13 inter medium white style={{ whiteSpace: 'nowrap' }}>
                      {`${authData?.firstName || ''} ${authData?.lastName || ''}`.trim() || 'User'}
                    </Text>
                    {roleText && (
                      <Text font12 inter regular grey3 style={{ whiteSpace: 'nowrap' }}>
                        {roleText}
                      </Text>
                    )}
                  </Flexbox>
                }
              >
                <InitialsAvatar
                  firstName={authData?.firstName}
                  lastName={authData?.lastName}
                  size={36}
                />
              </ToolTip>
              <LogOut onClick={() => {
								setPopupState(true);
							}} className={'pointer'}/>
            </Flexbox>
          </Flexbox>
        </WrapperBox>}
       <WrapperBox background={!isClassroomUser?globalTheme.colors.white:'transparent'} Height={'100%'} padding={isClassroomUser ? '20px' : (isCoworkAdmin || isLabAdmin || isBmbAdmin) ? '24px 28px' : '0'} borderRadius={isClassroomUser? 20: 0} className={`appMainScroll ${(isClassroomUser || isCoworkAdmin || isLabAdmin || isBmbAdmin) ? 'respPagePad' : ''}`}>
         <Outlet />
       </WrapperBox>
       </WrapperBox>
      </Flexbox>

    </WorkArea>
    </>
  );
};

export default MainLayout;